import React from 'react';

// Единый блок дашборда: заголовок + (опциональные) действия справа + контент.
export default function DashSection({ title, subtitle, actions, children }) {
  return (
    <section className="space-y-3">
      <div className="flex flex-wrap items-end justify-between gap-3">
        {title && (
          <div>
            <h2 className="text-base font-semibold text-ink leading-tight">{title}</h2>
            {subtitle && <p className="text-xs text-ink-tertiary mt-0.5">{subtitle}</p>}
          </div>
        )}
        {actions}
      </div>
      {children}
    </section>
  );
}
